const translations = {
  it: {
    // Nav
    nav_dashboard: "Dashboard",
    nav_restaurants: "Dove andare",
    nav_wallet: "Portafoglio",
    nav_my_reviews: "Le mie review",
    nav_my_restaurant: "La mia attività",
    nav_restaurant_dashboard: "Dashboard (attività)",
    nav_admin: "Admin",
    nav_sign_in: "Accedi",
    nav_sign_in_user: "Accedi come Utente",
    nav_sign_in_restaurant: "Accedi come Attività",
    nav_sign_out: "Esci",
    nav_notifications: "Notifiche",
    nav_mark_read: "Segna come lette",
    nav_no_notifications: "Nessuna notifica",
    // User Auth (email + password)
    back: "Indietro",
    back_home: "Torna alla home",
    ua_welcome_back: "Bentornato",
    ua_join_womio: "Unisciti a Womio",
    ua_tab_login: "Accedi",
    ua_tab_register: "Registrati",
    ua_email: "Email",
    ua_password: "Password",
    ua_password_confirm: "Ripeti password",
    ua_name: "Nome e Cognome",
    ua_pw_hint: "min 8 caratteri",
    ua_pw_mismatch: "Le password non coincidono",
    ua_pw_too_short: "La password deve avere almeno 8 caratteri",
    ua_code_invalid: "Codice non valido",
    ua_login_btn: "Accedi",
    ua_register_btn: "Crea account",
    ua_login_ok: "Accesso effettuato",
    ua_registered_check_email: "Ti abbiamo inviato un codice di verifica via email",
    ua_need_verify: "Devi verificare l'email prima di accedere",
    ua_verify_title: "Verifica la tua email",
    ua_verify_sent: "Abbiamo inviato un codice di 6 cifre a",
    ua_enter_code: "Inserisci il codice",
    ua_verify_btn: "Verifica e accedi",
    ua_verify_ok: "Email verificata!",
    ua_resend: "Invia di nuovo",
    ua_resend_in: "Invia di nuovo tra",
    ua_resend_ok: "Codice inviato di nuovo",
    ua_forgot_link: "Hai dimenticato la password?",
    ua_forgot_title: "Recupero password",
    ua_forgot_sub: "Ti invieremo un codice per reimpostare la password.",
    ua_forgot_btn: "Invia codice",
    ua_forgot_sent: "Se l'email esiste, riceverai un codice",
    ua_reset_title: "Reimposta password",
    ua_reset_sent: "Inserisci il codice ricevuto a",
    ua_new_password: "Nuova password",
    ua_reset_btn: "Reimposta password",
    ua_reset_ok: "Password aggiornata!",
    ua_or: "oppure",
    ua_continue_google: "Continua con Google",
    ua_loading: "Attendi...",
    ua_terms_notice: "Registrandoti accetti i Termini e la Privacy Policy di Womio.",
    // Landing
    landing_badge: "Solo review verificate",
    landing_h1_1: "Spendi. Passaparola.",
    landing_h1_2: "Guadagna!",
    landing_sub: "Scrivi recensioni autentiche con scontrini reali delle attività che ami. Quando le tue review portano nuovi clienti, guadagni coin.",
    landing_cta: "Inizia ora",
    landing_signup_free: "Iscriviti gratis",
    landing_customer_login: "Accedi come Cliente",
    landing_business_login: "Accedi come Attività",
    landing_business_signup: "Hai un'attività? Iscrivila su WOMio",
    landing_browse: "Scopri le attività",
    landing_how: "Come funziona",
    landing_how_sub: "Il circolo Womio",
    landing_step1_t: "Scegli un codice",
    landing_step1_d: "Scopri un'attività e seleziona il codice referral di una review verificata.",
    landing_step2_t: "Vai in negozio",
    landing_step2_d: "Visita l'attività, goditi l'esperienza e conserva lo scontrino.",
    landing_step3_t: "Scrivi la review",
    landing_step3_d: "Carica lo scontrino, scrivi la tua esperienza e inviala per la validazione.",
    landing_step4_t: "Guadagna coin",
    landing_step4_d: "Quando fai una recensione guadagni l'1% del tuo scontrino e quando qualcuno usa il tuo codice referral, guadagni il 4% del loro scontrino.",
    landing_step5_t: "Genera valore",
    landing_step5_d: "Ogni scontrino validato genera valore reale: sostieni le attività che ami, fai crescere la community e contribuisci ai progetti sociali scelti da WOMio.",
    landing_for_diners: "Per i clienti",
    landing_for_diners_d: "Scopri attività verificate e guadagna coin per ogni review.",
    landing_for_restaurants: "Per le attività",
    landing_for_restaurants_d: "Paghi solo per visite verificate, 3% di fee e 5% di buoni sconto, massima trasparenza.",
    landing_cta2: "Pronto a guadagnare e generare valore?",
    landing_cta2_sub: "Unisciti a WOMio. Accedi, inizia a recensire e a generare valore.",
    landing_cta2_btn: "Registrati gratis",
    // Action 2 Smile
    a2s_eyebrow: "Il nostro impegno",
    a2s_title: "Sosteniamo Action 2 Smile",
    a2s_body: "WOMio devolve l'intera somma del 3% di ogni scontrino validato alla società Action 2 Smile, che ha come scopo quello di portare sorrisi sul volto dei bambini. Ogni recensione contribuisce a una causa più grande.",
    a2s_cta: "Scopri il progetto",
    // Dashboard
    dash_title: "Bentornato",
    dash_balance: "Saldo attuale",
    dash_coins: "coin",
    dash_view_wallet: "Portafoglio",
    dash_reviews: "Review scritte",
    dash_drafts: "Bozze attive",
    dash_times_used: "Volte utilizzate",
    dash_value: "Valore generato",
    dash_coins_earned: "Coin guadagnati",
    dash_browse: "Scopri ristoranti",
    dash_browse_d: "Trova dove mangiare",
    dash_wallet: "Il tuo portafoglio",
    dash_wallet_d: "Controlla i tuoi guadagni",
    dash_recent: "Guadagni recenti",
    // Restaurants
    rest_discover: "Scopri",
    rest_title: "Dove andare ora",
    rest_search: "Cerca attività, categoria, zona...",
    rest_no_results: "Nessuna attività trovata.",
    rest_earn: "Guadagna 5%",
    rest_reviews: "review verificate",
    // Categories
    cat_all: "Tutte",
    cat_abbigliamento: "Abbigliamento e accessori",
    cat_bar: "Bar",
    cat_calzature: "Calzature",
    cat_casa_ferramenta: "Casa e ferramenta",
    cat_centro_estetico: "Centro estetico",
    cat_gastronomia: "Gastronomia e take-away",
    cat_gioielleria: "Gioielleria e accessori",
    cat_libreria: "Libreria e cartoleria",
    cat_animali: "Negozio per animali",
    cat_ottica: "Ottica",
    cat_panetteria: "Panetteria",
    cat_parrucchiere: "Parrucchiere",
    cat_pasticceria: "Pasticceria e gelateria",
    cat_pizzeria: "Pizzeria e pizza al taglio",
    cat_ristorante: "Ristorante",
    cat_altro: "Altro",
    // IBAN validation messages
    iban_empty: "Inserisci l'IBAN del conto corrente.",
    iban_invalid: "IBAN non valido. Controlla il codice inserito.",
    iban_valid: "IBAN formalmente valido",
    // Gallery
    gal_title: "Galleria vetrina",
    gal_all: "Tutte",
    gal_cat_locale: "Locale",
    gal_cat_prodotti: "Prodotti",
    gal_cat_listino: "Listino prezzi",
    gal_add_photo: "Aggiungi foto",
    gal_uploading: "Caricamento...",
    gal_cat_full: "Categoria piena",
    gal_max_reached: "Limite di 10 immagini raggiunto per questa categoria. Rimuovi una foto per aggiungerne un'altra.",
    gal_no_photos: "Nessuna foto disponibile",
    gal_no_photos_cat: "Nessuna foto in questa categoria",
    gal_set_cover: "Imposta come copertina",
    gal_delete: "Elimina",
    gal_confirm_delete: "Confermi l'eliminazione di questa foto?",
    gal_cover_set: "Copertina aggiornata",
    gal_uploaded: "Foto caricata",
    gal_deleted: "Foto eliminata",
    gal_too_big: "Immagine troppo grande (max 5MB)",
    gal_upload_err: "Errore durante il caricamento",
    gal_helper: "Carica foto del tuo locale, dei prodotti e del listino prezzi. Massimo 10 immagini per categoria, 5MB per foto.",
    gal_drag_hint: "Trascina le foto per riordinarle",
    gal_reorder_saved: "Ordine aggiornato",
    gal_reorder_err: "Errore nel riordino",
    // Admin gallery moderation
    admin_gal_tab: "Vetrina",
    admin_gal_title: "Moderazione vetrina",
    admin_gal_empty: "Nessuna immagine nella vetrina",
    admin_gal_confirm_del: "Eliminare questa immagine dalla vetrina dell'attività?",
    admin_gal_deleted: "Immagine eliminata",
    admin_gal_del_err: "Errore durante l'eliminazione",
    // Restaurant Detail
    rd_verified: "Verificata",
    rd_reviews: "Review verificate",
    rd_be_first: "Sii il primo a recensire!",
    rd_no_reviews: "Ancora nessuna review per questo ristorante.",
    rd_founder_code: "Il tuo draft sarà collegato al codice Womio Founder:",
    rd_write_review: "Scrivi una review",
    rd_use_code: "Usa questo codice",
    rd_about: "Info ristorante",
    rd_been_here: "Sei stato qui?",
    rd_been_here_d: "Condividi la tua esperienza e guadagna coin quando altri visitano!",
    rd_draft_created: "Draft creato! Vai al ristorante e poi completa dalla sezione 'Le mie review'.",
    rd_already_draft: "Hai già un draft attivo. Completalo o eliminalo prima.",
    // My Reviews
    mr_title: "Le mie review",
    mr_sub: "Gestisci le tue bozze e review",
    mr_no_reviews: "Nessuna review ancora. Scopri un ristorante per iniziare!",
    mr_complete: "Completa",
    mr_delete: "Elimina",
    mr_expires: "Scade",
    mr_submitted: "Inviata il",
    mr_your_code: "Il tuo codice",
    // Draft Completion
    dc_title: "Completa la review",
    dc_for: "per",
    dc_rating: "Valutazione",
    dc_rating_req: "Seleziona da 1 a 5 stelle",
    dc_text: "La tua recensione",
    dc_text_ph: "Racconta la tua esperienza...",
    dc_receipt: "Foto scontrino",
    dc_photo: "Foto personale (opzionale)",
    dc_submit: "Invia per validazione",
    dc_submitting: "Invio in corso...",
    dc_cancel: "Annulla",
    // Wallet
    w_title: "I tuoi guadagni e coin",
    w_balance: "Saldo",
    w_available: "coin disponibili",
    w_earned: "Totale guadagnato",
    w_spent: "Totale speso",
    w_transactions: "Transazioni",
    w_no_txns: "Nessuna transazione. Scrivi review per guadagnare coin!",
    w_coin_info: "I coin possono essere usati come sconto (max 4% del conto) nelle attività presenti nel circuito Womio. Ad 1 coin corrisponde 1 euro.",
    w_expiry: "I coin scadono dopo 6 mesi se non utilizzati.",
    // Receipt Upload
    ru_title: "Carica scontrino",
    ru_amount: "Importo scontrino (EUR)",
    ru_coins_label: "Usa coin come sconto",
    ru_coins_help: "Max 4% del conto. Dì all'attività di applicare lo sconto.",
    ru_receipt_img: "Foto scontrino",
    ru_submit: "Invia per validazione",
    ru_success: "Scontrino inviato!",
    ru_success_d: "Il tuo scontrino è in attesa di validazione dall'attività.",
    // Validations
    val_title: "Validazioni",
    val_receipts: "Scontrini",
    val_reviews: "Review",
    val_pending: "in attesa",
    val_approve: "Approva",
    val_reject: "Rifiuta",
    val_view: "Vedi",
    val_coins_used: "Coin usati",
    val_all_done: "Tutto in ordine!",
    val_no_pending: "Nessuna validazione in attesa.",
    // Statuses
    status_SAVED: "Bozza",
    status_IN_VALIDATION: "In validazione",
    status_VALIDATED: "Validata",
    status_EXPIRED: "Scaduta",
    status_DELETED: "Eliminata",
    // Restaurant Auth
    ra_title: "Area Attività",
    ra_register: "Registra la tua attività",
    ra_login: "Accedi",
    ra_ragione_sociale: "Ragione Sociale",
    ra_partita_iva: "Partita IVA",
    ra_iban: "IBAN Bancario",
    ra_email: "Email",
    ra_password: "Password",
    ra_address: "Indirizzo",
    ra_submit_register: "Registra attività",
    ra_submit_login: "Accedi",
    ra_switch_login: "Hai già un account? Accedi",
    ra_switch_register: "Non hai un account? Registrati",
    // Dashboard extras
    dash_coins_expiring: "Coin in scadenza tra 30gg",
    // Draft completion extras
    dc_receipt_amount: "Importo scontrino (EUR)",
    dc_receipt_amount_req: "L'importo scontrino è obbligatorio",
    dc_receipt_req: "La foto scontrino è obbligatoria",
    // Validation extras
    val_validate_btn: "Valida scontrino e importo",
    val_receipt_amount: "Importo scontrino",
    val_hint_blind: "Per garantire una validazione imparziale, il testo e la valutazione a stelle della recensione non sono visibili in questa fase. Saranno disponibili nella sezione 'Recensioni ricevute' dopo la validazione.",
    // Received reviews
    rr_title: "Recensioni ricevute",
    rr_subtitle: "Tutte le recensioni validate della tua attività",
    rr_total: "Recensioni totali",
    rr_avg: "Media stelle",
    rr_empty: "Nessuna recensione validata al momento.",
    nav_received_reviews: "Recensioni ricevute",
    loading: "Caricamento...",
    go_dashboard: "Vai alla Dashboard",
    upload: "Carica",
    click_change: "Clicca per cambiare",
    // Review new lifecycle (Parte 6+13)
    status_SAVED: "Bozza",
    status_IN_VALIDATION: "In validazione",
    status_CORRECTION_REQUIRED: "Da correggere",
    status_VALIDATED: "Validata",
    status_EXPIRED: "Scaduta",
    status_DELETED: "Eliminata",
    corr_banner_title: "Correzione richiesta",
    corr_reason_label: "Motivo indicato dall'attività",
    corr_reopen: "Riapri e modifica",
    corr_resubmit: "Invia nuovamente in approvazione",
    corr_confirm: "Conferma correzione",
    corr_amount: "Importo scontrino",
    corr_coins: "Coin utilizzati",
    corr_max_coin_hint: "Massimo 4% del pre-conto",
    corr_success: "Recensione reinviata in validazione",
    // Edit SAVED draft (Phase 17)
    ed_edit: "Modifica",
    ed_title: "Modifica bozza",
    ed_sub: "Aggiorna testo e valutazione senza inviare",
    ed_note: "Puoi salvare le modifiche e completare la bozza in un secondo momento.",
    ed_save: "Salva modifiche",
    ed_saved_ok: "Bozza aggiornata",
    ed_empty_error: "Inserisci un testo o una valutazione",
    // Phase 20 — Inactive referral
    ir_title: "Referral non più attivo",
    ir_body: "L'utente che hai selezionato non è più attivo su WOMIO.\nPuoi utilizzare questo scontrino scegliendo un altro utente.\nOppure puoi annullare questa recensione e scriverne una nuova.\nGrazie!",
    ir_back: "Torna alla modifica",
    ir_choose_new: "Scegli un altro referral",
    ir_cancel: "Annulla recensione",
    ir_toast_inactive: "L'utente scelto non è più attivo su WOMIO. Scegline un altro.",
    rd_referral_swapped: "Referral aggiornato con successo",
    // Phase 21 — Delete Account
    nav_delete_account: "Cancella account",
    nav_edit_profile: "Modifica profilo",
    nav_social_projects: "Progetti sociali",
    nav_admin_social_projects: "Gestione progetti",
    nav_support: "Assistenza",
    // Support dialog (Phase 25)
    sup_title: "Richiesta di assistenza",
    sup_subtitle: "Compila il form: ti risponderemo via email il prima possibile.",
    sup_reason_label: "Motivo della richiesta",
    sup_reason_placeholder: "Seleziona un motivo",
    sup_reason_technical_issue: "Problema tecnico / bug",
    sup_reason_review_issue: "Problema con review o scontrino",
    sup_reason_wallet_issue: "Problema con wallet o coin",
    sup_reason_business_issue: "Problema con un'attività",
    sup_reason_account_issue: "Account e profilo",
    sup_reason_suggestion: "Suggerimenti e miglioramenti",
    sup_reason_partnership: "Partnership / collaborazioni",
    sup_reason_other: "Altro",
    sup_message_label: "Messaggio",
    sup_message_placeholder: "Descrivi il problema o la richiesta nel modo più dettagliato possibile.",
    sup_attachment_label: "Allegato (opzionale)",
    sup_attachment_pick: "Carica immagine",
    sup_attachment_change: "Cambia immagine",
    sup_attachment_hint: "Formati accettati: JPG, PNG, WEBP · dimensione massima 5 MB",
    sup_submit: "Invia richiesta",
    sup_cancel: "Annulla",
    sup_sent: "Richiesta inviata. Ti ricontatteremo via email.",
    sup_err_reason: "Seleziona un motivo",
    sup_err_message_short: "Il messaggio deve avere almeno 10 caratteri",
    sup_err_message_long: "Il messaggio è troppo lungo",
    sup_err_type: "Formato non supportato. Ammessi: JPG, PNG, WEBP",
    sup_err_size: "L'immagine supera i 5 MB",
    sup_err_generic: "Errore durante l'invio. Riprova.",
    // Phase 24 — Social Projects (banner + profile + pages)
    sp_banner_title: "Il tuo passaparola può fare ancora di più",
    sp_banner_desc: "Scopri i progetti sociali dedicati ai bambini sostenuti da Action 2 Smile.",
    sp_banner_cta: "Scopri i progetti",
    sp_page_title: "Progetti sociali",
    sp_page_subtitle: "Scopri i progetti dedicati ai bambini sostenuti da Action 2 Smile e segui il loro percorso.",
    sp_empty_state: "Presto qui troverai i progetti sociali sostenuti da Action 2 Smile. I progetti saranno già avviati e potrai seguirne il percorso e il loro stato di avanzamento.",
    sp_card_association: "Associazione",
    sp_card_city: "Città",
    sp_card_purpose: "Scopo",
    sp_card_progress: "Avanzamento",
    sp_card_categories: "Categorie",
    sp_card_status: "Stato",
    sp_status_active: "Attivo",
    sp_status_completed: "Completato",
    sp_detail_back: "Torna ai progetti",
    pe_title: "Modifica profilo",
    pe_section_personal: "Dati personali",
    pe_name: "Nome",
    pe_surname: "Cognome",
    pe_mobile_prefix: "Prefisso",
    pe_mobile_number: "Cellulare",
    pe_birth_date: "Data di nascita",
    pe_birth_date_ph: "GG/MM/AAAA",
    pe_birth_date_invalid: "Data di nascita non valida",
    pe_birth_date_future: "La data di nascita non può essere futura",
    pe_birth_date_min_age: "Devi avere almeno 14 anni",
    pe_city: "Città di residenza",
    pe_gender: "Genere",
    pe_gender_woman: "Donna",
    pe_gender_man: "Uomo",
    pe_gender_non_binary: "Non binario",
    pe_gender_prefer_not_to_say: "Preferisco non dirlo",
    pe_interests_title: "I miei interessi sociali",
    pe_interests_intro: "Seleziona gli ambiti dei progetti sociali dedicati ai bambini che ti interessano di più.",
    pe_save: "Salva modifiche",
    pe_saved: "Profilo aggiornato con successo",
    pe_error: "Errore durante il salvataggio",
    // Admin social projects
    asp_tab: "Progetti sociali",
    asp_new: "Nuovo progetto",
    asp_title: "Titolo",
    asp_association: "Associazione",
    asp_city: "Città",
    asp_purpose: "Scopo",
    asp_progress: "Avanzamento (%)",
    asp_categories: "Categorie",
    asp_status: "Stato",
    asp_save: "Salva",
    asp_cancel: "Annulla",
    asp_edit: "Modifica",
    asp_created: "Progetto creato",
    asp_updated: "Progetto aggiornato",
    da_title: "Cancella account",
    da_body: "Vuoi cancellare il tuo account?\nIl tuo account WOMIO verrà disattivato e non potrai più accedervi.\nI dati storici necessari per l'integrità e l'audit del sistema potranno essere conservati in forma anonimizzata.\nSe in futuro ti registrerai nuovamente a WOMIO, verrà creato un nuovo account e non recupererai i vantaggi associati a questo account.\nQuesta operazione non può essere annullata.",
    da_confirm_label: "Scrivi DELETE per confermare",
    da_password_label: "Conferma la tua password",
    da_cancel: "Annulla",
    da_confirm_btn: "Cancella account",
    da_deleting: "Cancellazione in corso...",
    da_success_toast: "Il tuo account WOMIO è stato cancellato. Grazie per aver utilizzato WOMIO.",
    da_err_generic: "Non è stato possibile cancellare l'account. Riprova tra poco.",
    da_err_invalid_password: "Password non corretta.",
    da_err_password_required: "Inserisci la password per confermare la cancellazione.",
    da_err_confirmation: "Scrivi 'DELETE' per confermare la cancellazione.",
    da_err_role: "Questo account non può essere cancellato da qui.",
    // Validation UI (business)
    val_declared_coins: "Coin dichiarati dall'utente",
    val_coins_warning: "L'utente dichiara di aver utilizzato dei coin. Verifica che siano stati applicati come sconto sul conto.",
    val_request_correction: "Richiedi correzione",
    val_correction_reason_title: "Motivo della richiesta di correzione",
    val_correction_reason_placeholder: "Descrivi cosa deve correggere l'utente (es. importo non coerente, scontrino illeggibile, coin non applicati...)",
    val_correction_send: "Invia richiesta di correzione",
    val_correction_cancel: "Annulla",
    val_correction_min_reason: "Inserisci almeno 10 caratteri di motivazione",
    val_history: "Storico validazioni",
    // Contract of Adhesion
    ct_page_title: "Contratto di Adesione WOMIO",
    ct_subtitle: "Prima di attivare il tuo account, sottoscrivi elettronicamente il Contratto di Adesione.",
    ct_step_review: "Rivedi",
    ct_step_accept: "Accetta",
    ct_step_otp: "Codice",
    ct_step_signed: "Sottoscritto",
    ct_business_data: "Dati dell'Esercente",
    ct_data_readonly: "I dati sono in sola lettura. Se trovi un errore, torna al profilo per modificarli.",
    ct_edit_profile: "Modifica profilo",
    ct_field_company: "Ragione sociale",
    ct_field_vat: "Partita IVA",
    ct_field_fiscal: "Codice fiscale",
    ct_field_address: "Sede legale",
    ct_field_email: "Email",
    ct_field_phone: "Telefono",
    ct_field_iban: "IBAN",
    ct_field_legal_rep: "Legale rappresentante",
    ct_field_legal_rep_fc: "C.F. legale rappresentante",
    ct_contract_text: "Testo del contratto",
    bn_label: "Nome attività",
    bn_placeholder: "es. Trattoria Bella",
    bn_helper: "È il nome visibile ai clienti nell'elenco attività e nella ricerca.",
    bn_required: "Nome attività obbligatorio",
    cp_title: "Completa il profilo della tua azienda",
    cp_toast_created: "Account creato! Completa il profilo della tua azienda.",
    cp_banner_text: "Completa il profilo della tua azienda per accedere alla validazione scontrini e alla dashboard finanziaria.",
    cp_start: "Completa il profilo della tua azienda per iniziare.",
    cp_company_data: "Dati aziendali",
    cp_company_hint: "(non visibili ai clienti; per modificarli contatta l'admin)",
    cp_legal_title: "Contatti aziendali e Legale Rappresentante",
    act_title: "Dati della tua attività",
    act_cta: "Inserisci i dati della tua attività",
    act_helper: "Questi dati sono visibili ai clienti nella scheda della tua attività. Città e contatti compaiono anche nella vetrina.",
    act_street: "Indirizzo",
    act_street_ph: "es. Via Roma 42",
    act_postal: "CAP",
    act_city: "Città",
    act_province: "Provincia",
    act_province_ph: "es. MI",
    act_booking_email: "E-mail per prenotare",
    act_contacts: "Contatti per prenotare",
    act_contacts_ph: "es. Tel. 02 1234567 – WhatsApp 333 1234567",
    act_required: "Campo obbligatorio",
    act_invalid_postal: "CAP: 5 cifre",
    act_invalid_province: "Provincia: sigla di 2 lettere",
    act_invalid_email: "E-mail non valida",
    act_saved: "Dati attività salvati",
    act_map_title: "Posizione sulla mappa",
    act_map_helper: "Se il punto non è preciso, trascina il segnaposto e salva la posizione.",
    act_map_save: "Salva posizione",
    act_map_saved: "Posizione aggiornata",
    act_map_missing: "Posizione non trovata automaticamente: trascina il segnaposto sul punto giusto e salva.",
    act_map_approx: "Posizione approssimativa: verifica e sposta il segnaposto se serve.",
    act_map_after_save: "La mappa compare dopo aver salvato i dati dell'attività.",
    act_incomplete_title: "Dati attività mancanti",
    act_incomplete_text: "Inserisci indirizzo e contatti: senza questi dati i clienti non sanno dove trovarti.",
    act_directions: "Indicazioni stradali",
    act_contacts_label: "Contatti",
    act_book_label: "Prenota",
    act_edit: "Modifica",
    act_save: "Salva",
    act_cancel: "Annulla",
    ct_version: "Versione",
    ct_number: "Numero",
    ct_terms_1: "Ho letto il Contratto di Adesione alla piattaforma WOMIO e dichiaro di accettarne integralmente il contenuto.",
    ct_terms_2: "Dichiaro di agire in qualità di legale rappresentante o soggetto autorizzato a sottoscrivere il presente contratto per conto dell'Esercente.",
    ct_proceed: "Procedi alla sottoscrizione",
    ct_profile_incomplete: "Completa prima il profilo attività",
    ct_otp_title: "Verifica sottoscrizione",
    ct_otp_desc: "Abbiamo inviato un codice a 6 cifre a",
    ct_otp_validity: "Valido 5 minuti. Non condividere il codice con nessuno.",
    ct_otp_placeholder: "Codice a 6 cifre",
    ct_otp_verify: "Sottoscrivi il contratto",
    ct_otp_resend: "Rinvia codice",
    ct_otp_resend_wait: "Rinvia tra {s}s",
    ct_otp_change_email: "Email errata? Torna al profilo",
    ct_signing: "Stiamo finalizzando la sottoscrizione del tuo contratto...",
    ct_success_title: "Contratto sottoscritto con successo",
    ct_success_desc: "Il tuo account è ora attivo. Ti abbiamo inviato una copia del contratto via email.",
    ct_success_number: "Numero contratto",
    ct_success_signed: "Data sottoscrizione",
    ct_download_pdf: "Scarica PDF contratto",
    ct_go_dashboard: "Vai alla dashboard",
    ct_already_signed: "Contratto già sottoscritto",
    ct_view_signed: "Vedi il tuo contratto",
    ct_error_generic: "Si è verificato un errore. Riprova.",
    ct_error_expired: "Codice scaduto. Richiedi un nuovo codice.",
    ct_error_wrong: "Codice errato",
    ct_error_locked: "Troppi tentativi. Riprova tra 15 minuti.",
    ct_error_not_ready: "Sottoscrizione non disponibile al momento",
    ct_pending_banner: "Il tuo account è in attesa. Sottoscrivi il Contratto di Adesione per attivarlo.",
    ct_admin_tab: "Contratti",
    ct_admin_number: "Numero",
    ct_admin_business: "Attività",
    ct_admin_vat: "P. IVA",
    ct_admin_legal_rep: "Legale rappresentante",
    ct_admin_version: "Versione",
    ct_admin_status: "Stato",
    ct_admin_signed_at: "Data firma",
    ct_admin_pdf: "PDF",
    ct_admin_audit: "Audit trail",
    ct_admin_no_contracts: "Nessun contratto sottoscritto",
    ct_admin_template_tab: "Template",
    ct_admin_upload_new: "Carica nuova versione",
    ct_admin_tpl_version: "Versione",
    ct_admin_tpl_title: "Titolo",
    ct_admin_tpl_content: "Testo contratto",
    ct_admin_tpl_activate: "Attiva subito",
    ct_admin_tpl_save: "Salva template",
    ct_admin_event_viewed: "Contratto visualizzato",
    ct_admin_event_accepted: "Clausole accettate",
    ct_admin_event_otp_sent: "OTP inviato",
    ct_admin_event_otp_verified: "OTP verificato",
    ct_admin_event_otp_failed: "OTP fallito",
    ct_admin_event_signed: "Contratto firmato",
    ct_admin_event_pdf: "PDF generato",
    ct_admin_event_email: "Email inviata",
    ct_admin_event_template: "Template caricato",
  },
  en: {
    nav_dashboard: "Dashboard",
    nav_restaurants: "Where to go",
    nav_wallet: "Wallet",
    nav_my_reviews: "My Reviews",
    nav_my_restaurant: "My Business",
    nav_restaurant_dashboard: "Dashboard (business)",
    nav_admin: "Admin",
    nav_sign_in: "Sign in",
    nav_sign_in_user: "Sign in as User",
    nav_sign_in_restaurant: "Sign in as Business",
    nav_sign_out: "Sign Out",
    nav_notifications: "Notifications",
    nav_mark_read: "Mark all read",
    nav_no_notifications: "No notifications",
    // User Auth (email + password)
    back: "Back",
    back_home: "Back to home",
    ua_welcome_back: "Welcome back",
    ua_join_womio: "Join Womio",
    ua_tab_login: "Sign in",
    ua_tab_register: "Sign up",
    ua_email: "Email",
    ua_password: "Password",
    ua_password_confirm: "Repeat password",
    ua_name: "Full name",
    ua_pw_hint: "min 8 characters",
    ua_pw_mismatch: "Passwords do not match",
    ua_pw_too_short: "Password must be at least 8 characters",
    ua_code_invalid: "Invalid code",
    ua_login_btn: "Sign in",
    ua_register_btn: "Create account",
    ua_login_ok: "Signed in",
    ua_registered_check_email: "We've sent a verification code to your email",
    ua_need_verify: "You must verify your email before signing in",
    ua_verify_title: "Verify your email",
    ua_verify_sent: "We've sent a 6-digit code to",
    ua_enter_code: "Enter the code",
    ua_verify_btn: "Verify & sign in",
    ua_verify_ok: "Email verified!",
    ua_resend: "Resend",
    ua_resend_in: "Resend in",
    ua_resend_ok: "Code re-sent",
    ua_forgot_link: "Forgot password?",
    ua_forgot_title: "Password recovery",
    ua_forgot_sub: "We'll send you a code to reset your password.",
    ua_forgot_btn: "Send code",
    ua_forgot_sent: "If the email exists, you'll receive a code",
    ua_reset_title: "Reset password",
    ua_reset_sent: "Enter the code sent to",
    ua_new_password: "New password",
    ua_reset_btn: "Reset password",
    ua_reset_ok: "Password updated!",
    ua_or: "or",
    ua_continue_google: "Continue with Google",
    ua_loading: "Please wait...",
    ua_terms_notice: "By signing up you accept Womio's Terms and Privacy Policy.",
    landing_badge: "Verified Reviews Only",
    landing_h1_1: "Spend. Refer.",
    landing_h1_2: "Earn!",
    landing_sub: "Write honest reviews backed by real receipts from the businesses you love. When your reviews bring new customers, you earn coins.",
    landing_cta: "Get Started",
    landing_signup_free: "Sign up for free",
    landing_customer_login: "Customer login",
    landing_business_login: "Business login",
    landing_business_signup: "Own a business? List it on WOMio",
    landing_browse: "Browse Businesses",
    landing_how: "How It Works",
    landing_how_sub: "The Womio Loop",
    landing_step1_t: "Pick a code",
    landing_step1_d: "Discover a business and select a referral code from a verified review.",
    landing_step2_t: "Visit the store",
    landing_step2_d: "Enjoy the experience and keep your receipt.",
    landing_step3_t: "Write your review",
    landing_step3_d: "Upload the receipt, write your experience and submit for validation.",
    landing_step4_t: "Earn coins",
    landing_step4_d: "When you write a review you earn 1% of your receipt, and when someone uses your referral code you earn 4% of their receipt.",
    landing_step5_t: "Generate value",
    landing_step5_d: "Every validated receipt creates real value: you support the businesses you love, grow the community and contribute to the social projects chosen by WOMio.",
    landing_for_diners: "For Customers",
    landing_for_diners_d: "Discover verified businesses and earn rewards for every honest review.",
    landing_for_restaurants: "For Businesses",
    landing_for_restaurants_d: "Pay only for verified visits, 3% fee and 5% in discount vouchers — full transparency.",
    landing_cta2: "Ready to earn and generate value?",
    landing_cta2_sub: "Join WOMio. Sign in, start reviewing and generating value.",
    landing_cta2_btn: "Sign Up Free",
    // Action 2 Smile
    a2s_eyebrow: "Our Commitment",
    a2s_title: "We support Action 2 Smile",
    a2s_body: "WOMio donates the full 3% of every validated receipt to Action 2 Smile, whose mission is to bring smiles to children's faces. Every review contributes to a bigger cause.",
    a2s_cta: "Discover the project",
    dash_title: "Welcome back",
    dash_balance: "Current Balance",
    dash_coins: "coins",
    dash_view_wallet: "Wallet",
    dash_reviews: "Reviews Written",
    dash_drafts: "Active Drafts",
    dash_times_used: "Times Used",
    dash_value: "Value Generated",
    dash_coins_earned: "Coins Earned",
    dash_browse: "Browse Restaurants",
    dash_browse_d: "Find where to eat",
    dash_wallet: "Your Wallet",
    dash_wallet_d: "Track your earnings",
    dash_recent: "Recent Earnings",
    rest_discover: "Discover",
    rest_title: "Where to go now",
    rest_search: "Search businesses, category, area...",
    rest_no_results: "No businesses found.",
    rest_earn: "Earn 5%",
    rest_reviews: "verified reviews",
    cat_all: "All",
    cat_abbigliamento: "Clothing & Accessories",
    cat_bar: "Bar",
    cat_calzature: "Footwear",
    cat_casa_ferramenta: "Home & Hardware Store",
    cat_centro_estetico: "Beauty Salon",
    cat_gastronomia: "Deli & Takeaway",
    cat_gioielleria: "Jewelry & Accessories",
    cat_libreria: "Bookshop & Stationery",
    cat_animali: "Pet Shop",
    cat_ottica: "Optician",
    cat_panetteria: "Bakery",
    cat_parrucchiere: "Hair Salon",
    cat_pasticceria: "Pastry Shop & Ice Cream Shop",
    cat_pizzeria: "Pizzeria & Pizza by the Slice",
    cat_ristorante: "Restaurant",
    cat_altro: "Other",
    // IBAN validation messages
    iban_empty: "Please enter your bank account IBAN.",
    iban_invalid: "Invalid IBAN. Please check the code you entered.",
    iban_valid: "IBAN is formally valid",
    // Gallery
    gal_title: "Storefront gallery",
    gal_all: "All",
    gal_cat_locale: "Location",
    gal_cat_prodotti: "Products",
    gal_cat_listino: "Price list",
    gal_add_photo: "Add photo",
    gal_uploading: "Uploading...",
    gal_cat_full: "Category full",
    gal_max_reached: "Limit of 10 images reached for this category. Remove a photo to add another.",
    gal_no_photos: "No photos yet",
    gal_no_photos_cat: "No photos in this category",
    gal_set_cover: "Set as cover",
    gal_delete: "Delete",
    gal_confirm_delete: "Confirm deletion of this photo?",
    gal_cover_set: "Cover updated",
    gal_uploaded: "Photo uploaded",
    gal_deleted: "Photo deleted",
    gal_too_big: "Image too large (max 5MB)",
    gal_upload_err: "Upload error",
    gal_helper: "Upload photos of your location, products and price list. Max 10 images per category, 5MB per photo.",
    gal_drag_hint: "Drag photos to reorder",
    gal_reorder_saved: "Order updated",
    gal_reorder_err: "Reorder error",
    admin_gal_tab: "Gallery",
    admin_gal_title: "Gallery moderation",
    admin_gal_empty: "No images in the gallery",
    admin_gal_confirm_del: "Delete this image from the business gallery?",
    admin_gal_deleted: "Image deleted",
    admin_gal_del_err: "Deletion error",
    rd_verified: "Verified",
    rd_reviews: "Verified Reviews",
    rd_be_first: "Be the first to review!",
    rd_no_reviews: "No reviews yet for this restaurant.",
    rd_founder_code: "Your draft will be linked to the Womio Founder code:",
    rd_write_review: "Write a review",
    rd_use_code: "Use this code",
    rd_about: "About this restaurant",
    rd_been_here: "Been here recently?",
    rd_been_here_d: "Share your experience and earn coins when others visit!",
    rd_draft_created: "Draft created! Visit the restaurant, then complete from 'My Reviews'.",
    rd_already_draft: "You already have an active draft. Complete or delete it first.",
    mr_title: "My Reviews",
    mr_sub: "Manage your drafts and reviews",
    mr_no_reviews: "No reviews yet. Discover a restaurant to get started!",
    mr_complete: "Complete",
    mr_delete: "Delete",
    mr_expires: "Expires",
    mr_submitted: "Submitted on",
    mr_your_code: "Your code",
    dc_title: "Complete your review",
    dc_for: "for",
    dc_rating: "Rating",
    dc_rating_req: "Select 1 to 5 stars",
    dc_text: "Your review",
    dc_text_ph: "Share your experience...",
    dc_receipt: "Receipt photo",
    dc_photo: "Personal photo (optional)",
    dc_submit: "Submit for validation",
    dc_submitting: "Submitting...",
    dc_cancel: "Cancel",
    w_title: "Your earnings & coins",
    w_balance: "Balance",
    w_available: "coins available",
    w_earned: "Total Earned",
    w_spent: "Total Spent",
    w_transactions: "Transactions",
    w_no_txns: "No transactions yet. Write reviews to earn coins!",
    w_coin_info: "Coins can be used as a discount (max 4% of bill) at businesses in the Womio network. 1 coin equals 1 euro.",
    w_expiry: "Coins expire after 6 months if unused.",
    ru_title: "Upload Receipt",
    ru_amount: "Receipt Amount (EUR)",
    ru_coins_label: "Use coins as discount",
    ru_coins_help: "Max 4% of bill. Tell the business to apply the discount.",
    ru_receipt_img: "Receipt photo",
    ru_submit: "Submit for validation",
    ru_success: "Receipt submitted!",
    ru_success_d: "Your receipt is pending validation by the business.",
    val_title: "Validations",
    val_receipts: "Receipts",
    val_reviews: "Reviews",
    val_pending: "pending",
    val_approve: "Approve",
    val_reject: "Reject",
    val_view: "View",
    val_coins_used: "Coins used",
    val_all_done: "All caught up!",
    val_no_pending: "No pending validations.",
    ra_title: "Business Area",
    ra_register: "Register your business",
    ra_login: "Login",
    ra_ragione_sociale: "Company Name",
    ra_partita_iva: "VAT Number",
    ra_iban: "Bank IBAN",
    ra_email: "Email",
    ra_password: "Password",
    ra_address: "Address",
    ra_submit_register: "Register Business",
    ra_submit_login: "Login",
    ra_switch_login: "Already have an account? Login",
    ra_switch_register: "Don't have an account? Register",
    dash_coins_expiring: "Coins expiring in 30 days",
    dc_receipt_amount: "Receipt amount (EUR)",
    dc_receipt_amount_req: "Receipt amount is required",
    dc_receipt_req: "Receipt photo is required",
    val_validate_btn: "Validate receipt and amount",
    val_receipt_amount: "Receipt amount",
    val_hint_blind: "To ensure unbiased validation, the review text and star rating are hidden at this stage. They will be available in the 'Received Reviews' section after validation.",
    rr_title: "Received Reviews",
    rr_subtitle: "All validated reviews for your business",
    rr_total: "Total reviews",
    rr_avg: "Average rating",
    rr_empty: "No validated reviews yet.",
    nav_received_reviews: "Received Reviews",
    status_SAVED: "Draft",
    status_IN_VALIDATION: "In Validation",
    status_VALIDATED: "Validated",
    status_EXPIRED: "Expired",
    status_DELETED: "Deleted",
    back: "Back",
    loading: "Loading...",
    go_dashboard: "Go to Dashboard",
    upload: "Upload",
    click_change: "Click to change",
    // Review new lifecycle (Parte 6+13)
    status_SAVED: "Draft",
    status_IN_VALIDATION: "In validation",
    status_CORRECTION_REQUIRED: "Needs correction",
    status_VALIDATED: "Validated",
    status_EXPIRED: "Expired",
    status_DELETED: "Deleted",
    corr_banner_title: "Correction requested",
    corr_reason_label: "Reason from business",
    corr_reopen: "Reopen & edit",
    corr_resubmit: "Resubmit for approval",
    corr_confirm: "Confirm correction",
    corr_amount: "Receipt amount",
    corr_coins: "Coins used",
    corr_max_coin_hint: "Maximum 4% of pre-bill",
    corr_success: "Review resubmitted for validation",
    // Edit SAVED draft (Phase 17)
    ed_edit: "Edit",
    ed_title: "Edit draft",
    ed_sub: "Update text and rating without submitting",
    ed_note: "You can save your changes and complete the draft later.",
    ed_save: "Save changes",
    ed_saved_ok: "Draft updated",
    ed_empty_error: "Enter a text or a rating",
    // Phase 20 — Inactive referral
    ir_title: "Referral no longer active",
    ir_body: "The user you selected is no longer active on WOMIO.\nYou can still use this receipt by choosing another user.\nOr you can cancel this review and write a new one.\nThank you!",
    ir_back: "Back to edit",
    ir_choose_new: "Choose another referral",
    ir_cancel: "Cancel review",
    ir_toast_inactive: "The user you selected is no longer active on WOMIO. Please choose another.",
    rd_referral_swapped: "Referral updated successfully",
    // Phase 21 — Delete Account
    nav_delete_account: "Delete account",
    nav_edit_profile: "Edit Profile",
    nav_social_projects: "Social projects",
    nav_admin_social_projects: "Manage projects",
    nav_support: "Support",
    // Support dialog (Phase 25)
    sup_title: "Support request",
    sup_subtitle: "Fill in the form: we'll get back to you by email as soon as possible.",
    sup_reason_label: "Reason",
    sup_reason_placeholder: "Select a reason",
    sup_reason_technical_issue: "Technical issue / bug",
    sup_reason_review_issue: "Issue with a review or receipt",
    sup_reason_wallet_issue: "Issue with wallet or coins",
    sup_reason_business_issue: "Issue with a business",
    sup_reason_account_issue: "Account and profile",
    sup_reason_suggestion: "Suggestions and improvements",
    sup_reason_partnership: "Partnership / collaboration",
    sup_reason_other: "Other",
    sup_message_label: "Message",
    sup_message_placeholder: "Describe the issue or request in as much detail as possible.",
    sup_attachment_label: "Attachment (optional)",
    sup_attachment_pick: "Upload image",
    sup_attachment_change: "Change image",
    sup_attachment_hint: "Allowed formats: JPG, PNG, WEBP · max size 5 MB",
    sup_submit: "Send request",
    sup_cancel: "Cancel",
    sup_sent: "Request sent. We'll contact you by email.",
    sup_err_reason: "Please select a reason",
    sup_err_message_short: "The message must be at least 10 characters",
    sup_err_message_long: "The message is too long",
    sup_err_type: "Unsupported format. Allowed: JPG, PNG, WEBP",
    sup_err_size: "The image exceeds 5 MB",
    sup_err_generic: "Error while sending. Please try again.",
    // Phase 24 — Social Projects (banner + profile + pages)
    sp_banner_title: "Your word of mouth can do even more",
    sp_banner_desc: "Discover social projects for children supported by Action 2 Smile.",
    sp_banner_cta: "Discover projects",
    sp_page_title: "Social projects",
    sp_page_subtitle: "Discover projects for children supported by Action 2 Smile and follow their journey.",
    sp_empty_state: "Soon you will find here the social projects supported by Action 2 Smile. The projects will be already started and you'll be able to follow their journey and their progress status.",
    sp_card_association: "Association",
    sp_card_city: "City",
    sp_card_purpose: "Purpose",
    sp_card_progress: "Progress",
    sp_card_categories: "Categories",
    sp_card_status: "Status",
    sp_status_active: "Active",
    sp_status_completed: "Completed",
    sp_detail_back: "Back to projects",
    pe_title: "Edit profile",
    pe_section_personal: "Personal data",
    pe_name: "First name",
    pe_surname: "Last name",
    pe_mobile_prefix: "Prefix",
    pe_mobile_number: "Mobile",
    pe_birth_date: "Date of birth",
    pe_birth_date_ph: "DD/MM/YYYY",
    pe_birth_date_invalid: "Invalid date of birth",
    pe_birth_date_future: "Date of birth cannot be in the future",
    pe_birth_date_min_age: "You must be at least 14 years old",
    pe_city: "City of residence",
    pe_gender: "Gender",
    pe_gender_woman: "Woman",
    pe_gender_man: "Man",
    pe_gender_non_binary: "Non-binary",
    pe_gender_prefer_not_to_say: "Prefer not to say",
    pe_interests_title: "My social interests",
    pe_interests_intro: "Select the areas of social projects for children that interest you the most.",
    pe_save: "Save changes",
    pe_saved: "Profile updated successfully",
    pe_error: "Error while saving",
    // Admin social projects
    asp_tab: "Social projects",
    asp_new: "New project",
    asp_title: "Title",
    asp_association: "Association",
    asp_city: "City",
    asp_purpose: "Purpose",
    asp_progress: "Progress (%)",
    asp_categories: "Categories",
    asp_status: "Status",
    asp_save: "Save",
    asp_cancel: "Cancel",
    asp_edit: "Edit",
    asp_created: "Project created",
    asp_updated: "Project updated",
    da_title: "Delete account",
    da_body: "Do you want to delete your account?\nYour WOMIO account will be deactivated and you will no longer be able to access it.\nHistorical data required for the integrity and audit of the system may be kept in anonymized form.\nIf you register again on WOMIO in the future, a new account will be created and you will not recover any benefits associated with this account.\nThis action cannot be undone.",
    da_confirm_label: "Type DELETE to confirm",
    da_password_label: "Confirm your password",
    da_cancel: "Cancel",
    da_confirm_btn: "Delete account",
    da_deleting: "Deleting...",
    da_success_toast: "Your WOMIO account has been deleted. Thank you for using WOMIO.",
    da_err_generic: "We couldn't delete your account. Please try again shortly.",
    da_err_invalid_password: "Incorrect password.",
    da_err_password_required: "Enter your password to confirm deletion.",
    da_err_confirmation: "Type 'DELETE' to confirm deletion.",
    da_err_role: "This account cannot be deleted from here.",
    val_declared_coins: "Coins declared by user",
    val_coins_warning: "User declared they used coins as discount. Verify they were applied to the bill.",
    val_request_correction: "Request correction",
    val_correction_reason_title: "Correction reason",
    val_correction_reason_placeholder: "Describe what the user must fix (e.g. incorrect amount, unclear receipt, coins not applied...)",
    val_correction_send: "Send correction request",
    val_correction_cancel: "Cancel",
    val_correction_min_reason: "Please provide at least 10 characters",
    val_history: "Validation history",
    // Contract of Adhesion
    ct_page_title: "WOMIO Contract of Adhesion",
    ct_subtitle: "Before activating your account, electronically sign the Contract of Adhesion.",
    ct_step_review: "Review",
    ct_step_accept: "Accept",
    ct_step_otp: "Code",
    ct_step_signed: "Signed",
    ct_business_data: "Business data",
    ct_data_readonly: "Data is read-only. If you find an error, return to your profile to edit it.",
    ct_edit_profile: "Edit profile",
    ct_field_company: "Company name",
    ct_field_vat: "VAT number",
    ct_field_fiscal: "Fiscal code",
    ct_field_address: "Legal address",
    ct_field_email: "Email",
    ct_field_phone: "Phone",
    ct_field_iban: "IBAN",
    ct_field_legal_rep: "Legal representative",
    ct_field_legal_rep_fc: "Legal representative fiscal code",
    ct_contract_text: "Contract text",
    bn_label: "Business name",
    bn_placeholder: "e.g. Trattoria Bella",
    bn_helper: "This is the name customers see in the business list and in search.",
    bn_required: "Business name is required",
    cp_title: "Complete your company profile",
    cp_toast_created: "Account created! Complete your company profile.",
    cp_banner_text: "Complete your company profile to access receipt validation and the financial dashboard.",
    cp_start: "Complete your company profile to get started.",
    cp_company_data: "Company details",
    cp_company_hint: "(not visible to customers; contact the admin to change them)",
    cp_legal_title: "Company contacts and Legal Representative",
    act_title: "Your business details",
    act_cta: "Enter your business details",
    act_helper: "These details are shown to customers on your business page. City and contacts also appear in the storefront list.",
    act_street: "Address",
    act_street_ph: "e.g. Via Roma 42",
    act_postal: "Postcode",
    act_city: "City",
    act_province: "Province",
    act_province_ph: "e.g. MI",
    act_booking_email: "Booking e-mail",
    act_contacts: "Booking contacts",
    act_contacts_ph: "e.g. Tel. 02 1234567 – WhatsApp 333 1234567",
    act_required: "Required field",
    act_invalid_postal: "Postcode: 5 digits",
    act_invalid_province: "Province: 2-letter code",
    act_invalid_email: "Invalid e-mail",
    act_saved: "Business details saved",
    act_map_title: "Map position",
    act_map_helper: "If the point is not accurate, drag the pin and save the position.",
    act_map_save: "Save position",
    act_map_saved: "Position updated",
    act_map_missing: "Position not found automatically: drag the pin to the right spot and save.",
    act_map_approx: "Approximate position: check it and move the pin if needed.",
    act_map_after_save: "The map appears after you save your business details.",
    act_incomplete_title: "Business details missing",
    act_incomplete_text: "Add your address and contacts: without them customers cannot find you.",
    act_directions: "Get directions",
    act_contacts_label: "Contacts",
    act_book_label: "Book",
    act_edit: "Edit",
    act_save: "Save",
    act_cancel: "Cancel",
    ct_version: "Version",
    ct_number: "Number",
    ct_terms_1: "I have read the WOMIO Contract of Adhesion and I fully accept its content.",
    ct_terms_2: "I declare I am the legal representative or a subject authorised to sign this contract on behalf of the Business.",
    ct_proceed: "Proceed to signing",
    ct_profile_incomplete: "Complete your business profile first",
    ct_otp_title: "Signature verification",
    ct_otp_desc: "We sent a 6-digit code to",
    ct_otp_validity: "Valid for 5 minutes. Never share this code.",
    ct_otp_placeholder: "6-digit code",
    ct_otp_verify: "Sign the contract",
    ct_otp_resend: "Resend code",
    ct_otp_resend_wait: "Resend in {s}s",
    ct_otp_change_email: "Wrong email? Go back to profile",
    ct_signing: "Finalising your signature...",
    ct_success_title: "Contract signed successfully",
    ct_success_desc: "Your account is now active. We sent a copy of the contract to your email.",
    ct_success_number: "Contract number",
    ct_success_signed: "Signed at",
    ct_download_pdf: "Download contract PDF",
    ct_go_dashboard: "Go to dashboard",
    ct_already_signed: "Contract already signed",
    ct_view_signed: "View your contract",
    ct_error_generic: "An error occurred. Please try again.",
    ct_error_expired: "Code expired. Request a new one.",
    ct_error_wrong: "Wrong code",
    ct_error_locked: "Too many attempts. Try again in 15 minutes.",
    ct_error_not_ready: "Signing not available right now",
    ct_pending_banner: "Your account is pending. Sign the Contract of Adhesion to activate it.",
    ct_admin_tab: "Contracts",
    ct_admin_number: "Number",
    ct_admin_business: "Business",
    ct_admin_vat: "VAT",
    ct_admin_legal_rep: "Legal rep.",
    ct_admin_version: "Version",
    ct_admin_status: "Status",
    ct_admin_signed_at: "Signed at",
    ct_admin_pdf: "PDF",
    ct_admin_audit: "Audit trail",
    ct_admin_no_contracts: "No signed contracts",
    ct_admin_template_tab: "Templates",
    ct_admin_upload_new: "Upload new version",
    ct_admin_tpl_version: "Version",
    ct_admin_tpl_title: "Title",
    ct_admin_tpl_content: "Contract text",
    ct_admin_tpl_activate: "Activate immediately",
    ct_admin_tpl_save: "Save template",
    ct_admin_event_viewed: "Contract viewed",
    ct_admin_event_accepted: "Terms accepted",
    ct_admin_event_otp_sent: "OTP sent",
    ct_admin_event_otp_verified: "OTP verified",
    ct_admin_event_otp_failed: "OTP failed",
    ct_admin_event_signed: "Contract signed",
    ct_admin_event_pdf: "PDF generated",
    ct_admin_event_email: "Email sent",
    ct_admin_event_template: "Template uploaded",
  }
};

export default translations;
